import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppPreloader } from './app-preloader.service';
import { PageNotFoundComponent } from './containers';
import { PageNotFoundGuard } from './guards';
import { routes as mainRoutes } from './modules/main';

const routes: Routes = [
  ...mainRoutes,
  {
    path: '**',
    component: PageNotFoundComponent,
    canActivate: [PageNotFoundGuard],
  },
];

export const AppRoutes: ModuleWithProviders<RouterModule> = RouterModule.forRoot(
  routes,
  {
    preloadingStrategy: AppPreloader,
  }
);
